import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ErrorMessage } from '../models/errorMessage.model';
import { InfraService } from './infra.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { LanguageConstants, severitymessage } from '../shared-components/constant'
import { environment } from '../../environments/environment';
import { MsalService } from '@azure/msal-angular';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  errorMessage: ErrorMessage;
  private configCoreUrl: string;
  langCode: string;
  currLangTranslation: any;
  constructor(private injector: Injector, private infraService: InfraService, private http: HttpClient
    , private messageService: MessageService, private translateService: TranslateService, private msalService: MsalService) {
    this.initialiseModel();
    this.infraService.infraDetails$.subscribe(data => {
      this.configCoreUrl = data.WebEndPoint2 + 'logger';
    });
  }

  private initialiseModel() {
    this.errorMessage = {
      type: null,
      path: null,
      message: null
    }
  }

  // Angular wedges the running tick when the ErrorHandler itself throws, so every branch
  // below has to tolerate missing translations and errors without a `message`.
  private getTranslations(): any {
    const langCode = localStorage.getItem(LanguageConstants.LANG_CODE) || LanguageConstants.US_ENG_LOCALE;
    return this.translateService.translations?.[langCode]
      ?? this.translateService.translations?.[LanguageConstants.US_ENG_LOCALE]
      ?? {};
  }

  handleError(error: any) {
    const router = this.injector.get(Router);
    const errorMessageText = typeof error?.message === 'string' ? error.message : String(error);
    //console.log('Global handler: ' + router.url);
    if (error instanceof HttpErrorResponse) {
      if (error.status === 401) {
        router.navigate(['unauthorize'], { queryParams: { redirectFrom: 'engagement' } });
      } else {
        // Backend returns unsuccessful response codes such as 404, 500 etc.
        console.error('Backend returned status code: ', error.status);
        console.error('Response body:', error.message);
        const translations = this.getTranslations();
        this.messageService.add({
          key: severitymessage.key, severity: severitymessage.error, summary: translations.severitymessage?.notification,
          detail: translations.severitymessage?.somethingwrong
        });
      }
    } else {
      // A client-side or network error occurred.
      if (errorMessageText.startsWith('AADSTS50058: A silent sign-in request was sent but no user is signed in')
        || errorMessageText.startsWith('Token renewal operation failed due to timeout')) {
        const tokenRequest = {
             scopes: ["user.read"]
           };
           return this.msalService.acquireTokenRedirect(tokenRequest);
      } {
        console.error('An error occurred:', error);
        if (environment.env === 'local' || environment.env === 'dev' || environment.env === 'qa' || environment.env === 'uat') {
          this.errorMessage.type = 'Client Side Error';
          this.errorMessage.path = router.url;
          this.errorMessage.message = errorMessageText;
          this.logError(this.errorMessage).subscribe({ error: () => { } });
        }
      }
    }
  }

  private logError(errorMessage: ErrorMessage) {
    return this.http.post(`${this.configCoreUrl}/LogError`, errorMessage);
  }

}


